export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11789.0f339e5e.jpg";